import useAccessSettingActions from 'containers/Warehouse/hooks/useAccessSettingActions'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxSelector } from 'store'
import React from 'react'

interface SelectWarehouseSecuritySettingsPopupProps {
  showPinPopup: basic.BasicFunc
}

interface DataItem {
  key: string
  icon: string
  value?: 'biometricsSecured' | 'applicationPinSecured' | 'customPinSecured'
}

const data: DataItem[] = [{
  key: 'biometricAndAppPin',
  value: 'biometricsSecured',
  icon: 'fingerprint'
}, {
  key: 'appPin',
  value: 'applicationPinSecured',
  icon: 'pin'
}, {
  key: 'storagePin',
  value: 'customPinSecured',
  icon: 'pin'
}, {
  key: 'noSecurity',
  icon: 'close'
}]

const SelectWarehouseSecuritySettingsPopup: React.FC<SelectWarehouseSecuritySettingsPopupProps> = ({ showPinPopup }) => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const access = warehouse?.['2fa_access']

  const { isSending, action } = useAccessSettingActions()
  const { t } = useTranslation('warehouse')

  return (
    <Popup>
      <div className='popup__selectWarehouseAccessType'>
        <div className='popup__title'>
          <div>{t('accessSecurity')}</div>
          <div>{t('chooseSecurityMethod')}</div>
        </div>
        <div className='popup__selectWarehouseAccessType__options'>
          {data.map(item => {
            const isSelected = item.value
              ? access?.[item.value]
              : (!access?.biometricsSecured && !access?.applicationPinSecured && !access?.customPinSecured)

            return <div
              key={item.key}
              className={`popup__selectWarehouseAccessType__option${isSelected ? ' --selected' : ''}`}
              onClick={() => {
                if (isSending) return
                if (item.value) {
                  if (item.value === 'customPinSecured' && !isSelected) {
                    showPinPopup()
                  } else {
                    action({
                      biometricsSecured: false,
                      applicationPinSecured: false,
                      customPin: false,
                      [item.value]: !isSelected
                    })
                  }
                } else if (!isSelected) {
                  action({
                    biometricsSecured: false,
                    applicationPinSecured: false,
                    customPin: false
                  })
                }
              }}>
              <div className='group'>
                <i className={`icon icon--${item.icon} s30`} />
                <div className='popup__selectWarehouseAccessType__option__arrow center'>
                  <i className='icon icon--check' />
                </div>
              </div>
              <div className='popup__selectWarehouseAccessType__option__desc --secFont'>{t(item.key)}</div>
            </div>
          })}
        </div>
      </div>
    </Popup>
  )
}

export default SelectWarehouseSecuritySettingsPopup